import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { GuidePage } from './GuidePage'
import { QuestionnairePage } from './QuestionnairePage'

const PAGE_CONFIG = [
    { type: 'reading', title: 'Introduction' },
    { type: 'questionnaire', title: 'Questionnaire 1' },
    { type: 'reading', title: 'Section 2' },
    { type: 'questionnaire', title: 'Questionnaire 2' },
    { type: 'reading', title: 'Section 3' },
    { type: 'questionnaire', title: 'Questionnaire 3' },
]

export const DocumentationGuide = () => {
    const classes = useStyles()
    const [currentPage, setCurrentPage] = useState(0)
    const [allAnswers, setAllAnswers] = useState({})

    const goNext = () => {
        if (currentPage < PAGE_CONFIG.length - 1) {
            setCurrentPage(currentPage + 1)
        }
    }

    const goBack = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1)
        }
    }

    const saveAnswers = (pageIndex, answers) => {
        setAllAnswers({ ...allAnswers, [pageIndex]: answers })
    }

    const config = PAGE_CONFIG[currentPage]
    const isLastQuestionnaire = currentPage === PAGE_CONFIG.length - 1

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <h1 className={classes.title}>Documentation Guide</h1>
                <div className={classes.pageIndicator}>
                    Page {currentPage + 1} of {PAGE_CONFIG.length}
                </div>
            </div>

            <div className={classes.content}>
                {config.type === 'reading' && (
                    <GuidePage pageIndex={currentPage} />
                )}
                {config.type === 'questionnaire' && (
                    <QuestionnairePage
                        pageIndex={currentPage}
                        title={config.title}
                        allAnswers={allAnswers}
                        savedAnswers={allAnswers[currentPage] || {}}
                        onSaveAndContinue={(answers) => {
                            saveAnswers(currentPage, answers)
                            goNext()
                        }}
                        isLastQuestionnaire={isLastQuestionnaire}
                    />
                )}

                <div className={classes.navigation}>
                    <button
                        className={classes.navButton}
                        onClick={goBack}
                        disabled={currentPage === 0}
                    >
                        Back
                    </button>
                    <div className={classes.dots}>
                        {PAGE_CONFIG.map((_, i) => (
                            <span
                                key={i}
                                className={i === currentPage ? classes.dotActive : classes.dot}
                                onClick={() => setCurrentPage(i)}
                            />
                        ))}
                    </div>
                    <button
                        className={classes.navButton}
                        onClick={goNext}
                        disabled={currentPage === PAGE_CONFIG.length - 1}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f5f5f5',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    header: {
        padding: '24px 32px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        margin: 0,
        fontSize: 24,
        fontWeight: 600,
        color: '#333',
    },
    pageIndicator: {
        fontSize: 14,
        color: '#888',
    },
    content: {
        flex: 1,
        padding: 32,
        maxWidth: 800,
        width: '100%',
        margin: '0 auto',
        boxSizing: 'border-box',
    },
    navigation: {
        marginTop: 24,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    navButton: {
        padding: '10px 24px',
        fontSize: 14,
        fontWeight: 500,
        border: '1px solid #ccc',
        borderRadius: 4,
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover:not(:disabled)': {
            backgroundColor: '#f0f0f0',
        },
        '&:disabled': {
            opacity: 0.4,
            cursor: 'default',
        },
    },
    dots: {
        display: 'flex',
        gap: 8,
    },
    dot: {
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: '#ccc',
        cursor: 'pointer',
    },
    dotActive: {
        extend: 'dot',
        backgroundColor: '#333',
    },
})
